<template>
  <BookTitle :title="title" @bakToPrev="bakToPrev" @toggleChange="toggleChange">
    <template v-if="!$route.meta.keepAlive">
      <router-view :isChinese="isChinese"></router-view>
    </template>
    <template v-else>
      <router-view :isChinese="isChinese"></router-view>
    </template>
  </BookTitle>
</template>
<script>
import BookTitle from "@/components/StudyCenter/BookTitle";
export default {
  name: "review-home",
  data() {
    return {
      title: "book",
      isChinese: false,
    };
  },
  components: {
    BookTitle,
  },
  methods: {
    bakToPrev() {
      // this.$router.push({ path: "/StudyCenter" });
      // console.log("bakToPrev");
      // this.$router.go(-1)
      this.$router.push({
        path: "/StudyCenter",
      });
    },
    toggleChange(v) {
      this.isChinese = v;
    },
    getData() {
      console.log("getData");
    },
  },
};
</script>